import { render, staticRenderFns } from "./ProductDetailForm.vue?vue&type=template&id=51767402&"
import script from "./ProductDetailForm.vue?vue&type=script&lang=js&"
export * from "./ProductDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports